import { isMenuNavigationKey } from "@videojs/core/dom";
//#region src/ui/menu/keyboard.ts
const preventedEvents = /* @__PURE__ */ new WeakSet();
const canceledEvents = /* @__PURE__ */ new WeakSet();
function preventMenuKeyDefault(event) {
	if (event.key !== "Escape" && isMenuNavigationKey(event) && !event.defaultPrevented) {
		event.preventDefault();
		preventedEvents.add(event.nativeEvent);
	}
}
function callKeyDownHandler(handler, event) {
	const defaultPreventedBeforeHandler = event.defaultPrevented && (!preventedEvents.has(event.nativeEvent) || canceledEvents.has(event.nativeEvent));
	if (!handler) return defaultPreventedBeforeHandler;
	let defaultPreventedByHandler = false;
	const preventDefault = event.preventDefault;
	event.preventDefault = () => {
		defaultPreventedByHandler = true;
		preventDefault.call(event);
	};
	try {
		handler(event);
	} finally {
		event.preventDefault = preventDefault;
	}
	if (defaultPreventedByHandler) canceledEvents.add(event.nativeEvent);
	return defaultPreventedBeforeHandler || defaultPreventedByHandler;
}
//#endregion
export { callKeyDownHandler, preventMenuKeyDefault };

//# sourceMappingURL=keyboard.js.map